export default __webpack_public_path__ + "static/media/SURVIVE_2.df4fe8ad.jpg";